import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import validator from 'validator';
import Modal from 'react-bootstrap/Modal';
import BOOutlineButton from '../../../components/Widgets/Forms/BOOutlineButton';
import Input from '../../../bergmannsoft/components/Widgets/Forms/Input';
import InputDropdown from '../../../bergmannsoft/components/Widgets/Forms/InputDropdown';
import * as authService from '../../../services/auth';

import './styles.scss';

export default (props) => {
  const {
    users,
    organizations,
    history,
    permissions,
    isActive,
    getOpenStatusModal,
    searchValue,
  } = props;

  const companyId = useSelector(
    (state) => state.users.signedUser.selectedCompany._id
  );

  const listOnly = !!props.listOnly;
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [checkedPermissions, setCheckedPermissions] = useState([]);
  const [checkedOrganizations, setCheckedOrganizations] = useState([]);
  const [orgsCompany, setOrgsCompany] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const { i18n } = useTranslation();

  useEffect(() => {
    if (companyId && orgsCompany.length === 0 && organizations.length > 0) {
      let orgArray = [];

      orgArray = organizations.filter((org) => {
        return (
          org.companyId === companyId ||
          org.companyId.toString() === companyId.toString()
        );
      });

      setOrgsCompany(orgArray);
    }
  }, [users]);

  const save = async () => {
    if (checkedPermissions.length === 0) {
      toastr.error(
        i18n.t('Erro'),
        i18n.t('Selecione pelo menos uma Permissão.')
      );
    } else if (checkedOrganizations.length === 0) {
      toastr.error(
        i18n.t('Erro'),
        i18n.t('Selecione pelo menos uma organização.')
      );
    } else if (name.trim().length === 0) {
      toastr.error(i18n.t('Erro'), i18n.t('Digite o nome do usuário.'));
    } else if (email.trim().length === 0 || !validator.isEmail(email)) {
      await validates();
      toastr.error(i18n.t('Erro'), i18n.t('Insira um email válido.'));
    } else if (phoneNumber.trim().length <= 14) {
      toastr.error(i18n.t('Erro'), i18n.t('Digite o telefone do usuário.'));
    } else {
      await validates();

      const user = {
        name,
        email,
        phoneNumber,
        claim: checkedPermissions.name,
        organizationId: checkedOrganizations,
      };
      const { createUser } = props;

      createUser(user);
    }
  };

  let content = <div>Sem itens para exibir.</div>;

  if (users && users.length > 0) {
    content = users
      .filter((el) => {
        return (
          el.name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0 ||
          el.email.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
        );
      })
      .map((item, index) => (
        <div
          key={index}
          className="d-flex align-items-center pt-2 pb-2 pl-2 pr-1 users-content-line"
        >
          <img
            src={
              item.profilePhoto ||
              require('../../../assets/images/user_no_profile_photo.svg')
            }
            alt=""
          />
          <div className="users-content-line-data row">
            <div className="col-md-12 users-content-line-data-name">
              {item.name}
            </div>
            <div className="col-md-6 users-content-line-data-other">
              {item.email}
            </div>
            <div className="col-md-6 users-content-line-data-other">
              CPF: {item.cpf || '-'}
            </div>
          </div>
          {!listOnly ? (
            <BOOutlineButton
              className="btn-bo-users"
              onClick={() => history.push(`/preferencias/usuarios/${item._id}`)}
            >
              ver mais
            </BOOutlineButton>
          ) : (
            <div />
          )}
        </div>
      ));
  }

  const validates = async () => {
    if (!validator.isEmail(email)) {
      setErrorMessage('Insira um email válido!');
    } else {
      const result = await authService.checkEmailWithCompany(
        email,
        checkedOrganizations[0]
      );
      if (!result.data.valid) {
        setErrorMessage(result.data.message);
      }
      if (
        result.data.message === 'Este email não corresponde a nenhuma conta'
      ) {
        setErrorMessage('');
        closeModal();
      }
      if (result.data.message === undefined) {
        setErrorMessage('Email já cadastrado');
        toastr.error(i18n.t('Erro'), i18n.t('Email já existe'));
      }
    }
  };

  const closeModal = () => {
    setName('');
    setName('');
    setEmail('');
    setPhoneNumber('');
    setCheckedPermissions([]);
    setCheckedOrganizations([]);
    getOpenStatusModal();
  };

  return (
    <Fragment>
      <div className="users-content"> {content} </div>
      <Modal
        show={isActive}
        onHide={closeModal}
        className="modal-tag modal-content-tag"
      >
        <Modal.Header closeButton>
          <Modal.Title>Novo usuário</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div>
            <Input
              className="settings-content-modal-input"
              label={i18n.t('Nome')}
              placeholder={i18n.t('Nome Sobrenome')}
              value={name}
              onChange={(value) => setName(value)}
            />
            <Input
              className="settings-content-modal-input"
              label={i18n.t('Email')}
              placeholder={i18n.t('usuario@empresa.com.br')}
              value={email}
              onChange={(value) => setEmail(value)}
            />
            {errorMessage === '' ? null : (
              <p className="error-feedback-ipn">{errorMessage}</p>
            )}
            <Input
              className="settings-content-modal-input"
              mask="(99) 99999 9999"
              error
              maskChar=" "
              onChange={(value) => setPhoneNumber(value)}
              value={phoneNumber}
              placeholder={i18n.t('(00) 9 9999 9999')}
              label={i18n.t('Telefone')}
            />
            <InputDropdown
              className="settings-content-modal-input"
              label={i18n.t('Permissão')}
              placeholder={i18n.t('Selecine uma permissão')}
              dropdownItemsList={(permissions || []).filter(
                (permission) => permission.name !== 'Root'
              )}
              onChange={(items) => setCheckedPermissions(items)}
              useCheckbox={false}
              styleWidth={316}
            />
            <InputDropdown
              className="settings-content-modal-input"
              label={i18n.t('Setores')}
              placeholder={i18n.t('Selecine um setor.')}
              dropdownItemsList={orgsCompany || []}
              dropdownItemsChecked={checkedOrganizations}
              onChange={(items) => setCheckedOrganizations(items)}
              useCheckbox
              styleWidth={316}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            id=""
            className="btn btn-primary"
            data-dismiss
            onClick={save}
          >
            {i18n.t('salvar')}
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};
